var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 88,
    viewBox: "0 0 115 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.29 6.308c-8.387 8.41-8.387 22.048 0 30.459 8.386 8.41 21.983 8.41 30.37 0 8.386-8.411 8.386-22.048 0-30.459A21.376 21.376 0 0 0 21.475 0 21.376 21.376 0 0 0 6.29 6.308",
    id: "jgfoemb58a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29 6.308c-8.387 8.41-8.387 22.048 0 30.459 8.386 8.41 21.983 8.41 30.37 0 8.386-8.411 8.386-22.048 0-30.459A21.376 21.376 0 0 0 21.475 0 21.376 21.376 0 0 0 6.29 6.308",
    id: "8bqbuje8sc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29 6.308c-8.387 8.41-8.387 22.048 0 30.459 8.386 8.41 21.983 8.41 30.37 0 8.386-8.411 8.386-22.048 0-30.459A21.376 21.376 0 0 0 21.475 0 21.376 21.376 0 0 0 6.29 6.308",
    id: "1bzpfpgsfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29 6.308c-8.387 8.41-8.387 22.048 0 30.459 8.386 8.41 21.983 8.41 30.37 0 8.386-8.411 8.386-22.048 0-30.459A21.376 21.376 0 0 0 21.475 0 21.376 21.376 0 0 0 6.29 6.308",
    id: "laqpepthxg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.543 24.532a21.387 21.387 0 0 1 6.925-4.648V6.627C59.468 2.967 56.51 0 52.861 0H6.608C2.958 0 0 2.967 0 6.627V19.88c0 3.66 2.958 6.627 6.608 6.627H50.82a21.613 21.613 0 0 1 1.723-1.976",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47 8.29a1.654 1.654 0 0 1-1.653-1.657c0-.914.74-1.656 1.652-1.656l40.436-.007c.912 0 1.652.742 1.652 1.657s-.74 1.656-1.652 1.656L7.469 8.29zM7.47 14.949a1.654 1.654 0 0 1-1.653-1.657c0-.915.74-1.657 1.652-1.657l47.043-.038c.912 0 1.652.742 1.652 1.656 0 .915-.74 1.657-1.652 1.657L7.47 14.95zM7.47 21.607a1.654 1.654 0 0 1-1.653-1.656c0-.915.74-1.657 1.652-1.657l32.176-.07c.912 0 1.652.741 1.652 1.656 0 .915-.74 1.657-1.652 1.657l-32.176.07z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38 56.329H23.127c-3.65 0-6.608-2.968-6.608-6.627V36.448c0-3.66 2.958-6.627 6.608-6.627H69.38c3.649 0 6.607 2.967 6.607 6.627v13.254c0 3.66-2.958 6.627-6.607 6.627",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.897 38.254a1.654 1.654 0 0 1-1.652-1.657c0-.915.74-1.656 1.652-1.656l39.527-.15c.912 0 1.652.742 1.652 1.657s-.74 1.656-1.652 1.656l-39.527.15zM24.897 44.913a1.654 1.654 0 0 1-1.652-1.657c0-.915.74-1.657 1.652-1.657l46.134-.181c.912 0 1.652.742 1.652 1.656 0 .915-.74 1.657-1.652 1.657l-46.134.182zM24.897 51.571a1.654 1.654 0 0 1-1.652-1.657c0-.914.74-1.656 1.652-1.656l31.267-.213c.912 0 1.652.741 1.652 1.656 0 .915-.74 1.657-1.652 1.657l-31.267.213z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E0E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.706 59.642H6.608a6.577 6.577 0 0 0-4.673 1.94A6.616 6.616 0 0 0 0 66.27v13.254a6.614 6.614 0 0 0 1.935 4.686 6.577 6.577 0 0 0 4.673 1.94H52.86a6.577 6.577 0 0 0 4.672-1.94 6.614 6.614 0 0 0 1.92-4.245c.01-.146.015-.293.015-.441V66.269c0-1.83-.74-3.487-1.935-4.686a6.577 6.577 0 0 0-4.672-1.941h-3.155z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.47 68.218a1.654 1.654 0 0 1-1.653-1.657c0-.915.74-1.657 1.652-1.657l40.436-.292c.912 0 1.652.742 1.652 1.657 0 .914-.74 1.656-1.652 1.656l-40.436.293zM7.47 74.876a1.654 1.654 0 0 1-1.653-1.656c0-.915.74-1.657 1.652-1.657l47.043-.324c.912 0 1.652.742 1.652 1.656 0 .915-.74 1.657-1.652 1.657l-47.043.324zM7.47 81.52a1.654 1.654 0 0 1-1.653-1.658c0-.914.74-1.656 1.652-1.656l32.176-.34c.912 0 1.652.741 1.652 1.656 0 .915-.74 1.657-1.652 1.657l-32.176.34z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.065 86.059a6.594 6.594 0 0 1-9.345 0L89.703 72.001a6.64 6.64 0 0 1 0-9.371 6.594 6.594 0 0 1 9.345 0l14.017 14.057a6.64 6.64 0 0 1 0 9.372",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.691 66.63a3.297 3.297 0 0 1-4.672 0l-5.64-5.657a3.32 3.32 0 0 1 0-4.686 3.297 3.297 0 0 1 4.673 0l5.64 5.656a3.32 3.32 0 0 1 0 4.686",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.913 54.99c-8.387 8.411-21.984 8.411-30.37 0-8.386-8.41-8.386-22.047 0-30.458 8.386-8.411 21.983-8.411 30.37 0 8.386 8.41 8.386 22.048 0 30.458m3.504-33.973c-10.322-10.351-27.057-10.351-37.378 0-10.322 10.352-10.322 27.136 0 37.488 10.321 10.352 27.056 10.352 37.378 0 10.321-10.352 10.321-27.136 0-37.488",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.253 18.224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6fyyz8kv6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jgfoemb58a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.082 48.045h-52.86c-3.65 0-6.608-2.967-6.608-6.627V14.91c0-3.66 2.958-6.626 6.608-6.626h52.86c3.65 0 6.608 2.966 6.608 6.626v26.508c0 3.66-2.959 6.627-6.608 6.627",
    fill: "#E0E0E0",
    mask: "url(#6fyyz8kv6b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.253 18.224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "df1mc652ud",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8bqbuje8sc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.519 21.537h-29.734a3.309 3.309 0 0 1-3.304-3.313c0-1.83 1.48-3.314 3.304-3.314h29.734a3.309 3.309 0 0 1 3.304 3.314c0 1.83-1.48 3.313-3.304 3.313",
    fill: "#FFF",
    mask: "url(#df1mc652ud)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.253 18.224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "og0dbz79vf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1bzpfpgsfe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.778 31.478h-37.993a3.309 3.309 0 0 1-3.304-3.314c0-1.83 1.48-3.313 3.304-3.313h37.993a3.309 3.309 0 0 1 3.304 3.313c0 1.83-1.48 3.314-3.304 3.314",
    fill: "#FFF",
    mask: "url(#og0dbz79vf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.253 18.224)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "db5ko7ec9h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#laqpepthxg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.26 41.418h-21.475a3.309 3.309 0 0 1-3.304-3.313c0-1.83 1.48-3.314 3.304-3.314H8.259a3.309 3.309 0 0 1 3.304 3.314c0 1.83-1.479 3.313-3.304 3.313",
    fill: "#FFF",
    mask: "url(#db5ko7ec9h)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNewIcon);
export default __webpack_public_path__ + "static/media/search-new-icon.7c0044411fb80800ef977d094b399596.svg";
export { ForwardRef as ReactComponent };